import { css } from "@emotion/react";

export const header = css`
  margin-top: 1rem;
`;

export const container = css`
  display: flex;
  flex-direction: column;
`;

export const hidden = css`
  display: none;
`;

export const checkboxContainer = css`
  &:not(:last-of-type) {
    margin: 0.25rem 0;
  }
`;

export const loadMoreBrandsButton = css`
  display: flex;
  justify-content: center;
  margin: 0.5rem;
`;
